var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "grid-table-cell",
    _vm._b(
      { staticClass: "gfua-tree__leaf-wrapper" },
      "grid-table-cell",
      { ..._vm.$attrs, ..._vm.$props },
      false
    ),
    [_c("div", { class: _vm.classes }, [_vm._t("default")], 2)]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }